import { Tag as AntTag } from 'antd';
import classNames from 'classnames';
// import '@style/components/tag.scss';
import '../styles/components/tag.scss';
import React from 'react';
const Tag = ({ className, children, ...restProps }) => {
  const classes = classNames('ma-tag', className);
  return (
    <AntTag className={classes} {...restProps}>
      {children}
    </AntTag>
  );
};

export default Tag;
